export const ObservationReportDocumentsMapper = {
  toPageData: (observationReport, observationReportEventOrgWithOrgUnits) => ({
    id: observationReport.Id,
    eventId: observationReport.EventId,
    observedUserId: observationReport.ObservedUser.Id,
    observedUserName: observationReport.ObservedUser.FullName,
    result: observationReport.Result,
    orgName: observationReportEventOrgWithOrgUnits?.Name,
    orgUnitNames: getOrgUnitNames(observationReportEventOrgWithOrgUnits),
    document: observationReport.Document
      ? {
          id: observationReport.Document.Id,
          fileName: observationReport.Document.FileName,
          comment: observationReport.Document.Comment,
          status: observationReport.Document.Status,
          reviewerName: observationReport.Document.ReviewerName
        }
      : {}
  }),

  toApolloInput: observationReportDocument => ({
    ObservedUserId: observationReportDocument.observedUserId,
    EventId: observationReportDocument.eventId,
    FileName: observationReportDocument.file.name
  }),

  toReviewApolloInput: (reportId, document, status) => ({
    ReportId: reportId,
    Result: document.result,
    Comment: document.comment,
    Status: status
  })
};

const getOrgUnitNames = observationReportEventOrgWithOrgUnits =>
  observationReportEventOrgWithOrgUnits?.MddapOrgUnits.map(x => x.Name).join(', ');
